import React, { useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { StateDirectoryService } from './StateDirectoryService';

export const StateDirectoryContainer = ({ timeout, ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  }

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="state-directory">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <StateDirectoryService {...props} />
    </QueryProvider>
  );
};

StateDirectoryContainer.propTypes = {
  timeout: oneOfType([string, number])
};

StateDirectoryContainer.defaultProps = {
  timeout: '3000'
};
